import {
  IProductGrid,
  LOAD_MERCHANDISE_RELEASES_FILTERS,
  LOAD_MERCHANDISE_SUBMISSIONS_FILTERS,
  LOAD_PHYSICAL_RELEASES_FILTERS,
  LOAD_PHYSICAL_SUBMISSIONS_FILTERS,
} from '../actions/productGridActions';

export default function productGridReducer(
  state: IProductGrid | any = {},
  action: any
): object {
  switch (action.type) {
    case LOAD_PHYSICAL_RELEASES_FILTERS:
      return {
        ...state,
        physicalReleasesGridParams:
          action.productGridState.physicalReleasesGridParams,
      };
    case LOAD_PHYSICAL_SUBMISSIONS_FILTERS:
      return {
        ...state,
        physicalSubmissionsGridParams:
          action.productGridState.physicalSubmissionsGridParams,
      };
    case LOAD_MERCHANDISE_RELEASES_FILTERS:
      return {
        ...state,
        merchandiseReleasesGridParams:
          action.productGridState.merchandiseReleasesGridParams,
      };
    case LOAD_MERCHANDISE_SUBMISSIONS_FILTERS:
      return {
        ...state,
        merchandiseSubmissionsGridParams:
          action.productGridState.merchandiseSubmissionsGridParams,
      };
    default:
      return state;
  }
}
